import { render, staticRenderFns } from "./dialog-add-surface.vue?vue&type=template&id=21b1b5b2&scoped=true&"
import script from "./dialog-add-surface.vue?vue&type=script&lang=js&"
export * from "./dialog-add-surface.vue?vue&type=script&lang=js&"
import style0 from "./dialog-add-surface.vue?vue&type=style&index=0&id=21b1b5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1b5b2",
  null
  
)

export default component.exports